// src/games/quiz/quizConstants.js
import { designTokens } from '../../theme/theme';

export const QUIZ_TOPICS = [
  { id: 'general',    label: 'General Knowledge', icon: '🌍', color: designTokens.games.quizTopics.general },
  { id: 'science',    label: 'Science',            icon: '🔬', color: designTokens.games.quizTopics.science },
  { id: 'history',    label: 'History',            icon: '🏛️',  color: designTokens.games.quizTopics.history },
  { id: 'geography',  label: 'Geography',          icon: '🗺️',  color: designTokens.games.quizTopics.geography },
  { id: 'sports',     label: 'Sports',             icon: '⚽',  color: designTokens.games.quizTopics.sports },
  { id: 'movies',     label: 'Movies & TV',        icon: '🎬',  color: designTokens.games.quizTopics.movies },
  { id: 'music',      label: 'Music',              icon: '🎵',  color: designTokens.games.quizTopics.music },
  { id: 'technology', label: 'Technology',         icon: '💻',  color: designTokens.games.quizTopics.technology },
  { id: 'food',       label: 'Food & Drink',        icon: '🍕',  color: designTokens.games.quizTopics.food },
  { id: 'nature',     label: 'Nature',              icon: '🌿',  color: designTokens.games.quizTopics.nature },
];

export const TOPIC_MAP = Object.fromEntries(QUIZ_TOPICS.map(t => [t.id, t]));

export const QUIZ_SETTINGS = {
  minPlayers: 2,
  maxPlayers: 12,
  questionCount: 8,
  answerTime: 20,
  revealTime: 4,
  maxScore: 1000,
};

export const POINTS_PER_SECOND = Math.floor(QUIZ_SETTINGS.maxScore / QUIZ_SETTINGS.answerTime);
export const OPTION_LABELS = ['A', 'B', 'C', 'D'];
export const OPTION_COLORS = designTokens.games.quizOptions;

export function toPublicQuizQuestions(questions) {
  return questions.map(({ question, options, resource }) => ({
    question,
    options,
    resource: resource || '',
  }));
}

export function getQuizAnswerResult(optionIndex, correctIndex, submittedAt, startedAt) {
  if (!Number.isInteger(optionIndex) || optionIndex < 0 || optionIndex > 3 ||
      !Number.isInteger(correctIndex) || correctIndex < 0 || correctIndex > 3 ||
      !Number.isFinite(submittedAt) || !Number.isFinite(startedAt)) {
    return { correct: false, score: 0, late: true };
  }

  const elapsed = Math.max(0, (submittedAt - startedAt) / 1000);
  if (elapsed > QUIZ_SETTINGS.answerTime) return { correct: false, score: 0, late: true };

  const correct = optionIndex === correctIndex;
  const score = correct
    ? Math.min(QUIZ_SETTINGS.maxScore, Math.max(
      50,
      QUIZ_SETTINGS.maxScore - Math.floor(elapsed * POINTS_PER_SECOND)
    ))
    : 0;
  return { correct, score, late: false };
}
